import {styled, Box} from '@mui/material';

export const CUBIC_BEZIER = 'cubic-bezier(0.4, 0, 0.2, 1)';

export const IconWrapper = styled(Box)({
  width: '20px',
  minWidth: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});
